var _ellipse, _path, _path2, _circle, _circle2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse2, _path9, _path10, _circle3, _path11, _path12, _circle4, _circle5, _path13, _path14, _path15, _path16, _circle6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoResponse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 148,
    height: 150,
    fill: "none",
    viewBox: "0 0 148 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.57,
    cy: 143.591,
    fill: "#2B2B2B",
    rx: 53.052,
    ry: 6.409
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6D6D6D",
    fillRule: "evenodd",
    d: "M78.6997 82.0231L91.2848 94.633L100.954 85.3167L86.1739 71.2439L78.6997 82.0231Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6D6D6D",
    fillRule: "evenodd",
    d: "M90.9646 95.7515L84.6992 129.83H108.764L102.211 94.6328L90.9646 95.7515ZM94.0812 104.011H99.4808L103.41 124.799H90.244L94.0812 104.011Z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 96.763,
    cy: 90.788,
    r: 9.474,
    fill: "#B0B0B0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.763,
    cy: 90.789,
    r: 5.291,
    fill: "#6D6D6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B0B0",
    fillRule: "evenodd",
    d: "M78.6758 131.165C78.6758 129.592 79.9511 128.317 81.5242 128.317H112.002C113.575 128.317 114.85 129.592 114.85 131.165V139.637H78.6758V131.165Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6D6D6D",
    strokeWidth: 1.723,
    d: "M49.5856 64.7724L43.5688 37.4514"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6D6D6D",
    strokeWidth: 1.723,
    d: "M43.5688 37.4514L63.875 57.8219"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6D6D6D",
    strokeWidth: 1.723,
    d: "M43.5688 37.4514L72.0208 43.9861"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#6D6D6D",
    d: "M92.9337 105.216L93.8026 104.087L102.728 110.96L92.8965 115.999L104.352 123.375L103.581 124.572L90.0479 115.859L100.079 110.718L92.9337 105.216Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#9F9F9F",
    fillRule: "evenodd",
    d: "M86.9201 24.6989C86.1445 23.7101 84.6884 23.639 83.7974 24.5253L30.4064 77.6374C29.5641 78.4754 29.5696 79.837 30.4507 80.6341C31.8133 81.8668 33.8266 83.5817 35.5258 84.5982C47.5593 91.7975 69.7945 95.9416 85.4568 79.1592C101.043 62.4589 98.418 43.5667 91.2978 30.9204C90.2275 29.0195 88.2718 26.4224 86.9201 24.6989Z",
    clipRule: "evenodd"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.875,
    cy: 60.537,
    fill: "#C1C1C1",
    rx: 28.998,
    ry: 30.341
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#6D6D6D",
    fillRule: "evenodd",
    d: "M71.5393 139.126C71.5393 138.326 72.189 137.683 72.9885 137.701C77.2887 137.797 90.0901 138.071 96.7316 138.071C103.387 138.071 116.437 137.796 120.785 137.7C121.584 137.683 122.233 138.326 122.233 139.125V143.2C122.233 143.562 121.968 143.866 121.607 143.902C119.035 144.164 108.851 145.116 96.7316 145.116C84.6339 145.116 74.6939 144.168 72.1634 143.904C71.8035 143.866 71.5393 143.563 71.5393 143.202L71.5393 139.126Z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    fillRule: "evenodd",
    d: "M102.165 128.317C102.165 128.317 103.682 128.496 103.682 130.189C103.682 131.882 103.682 136.944 103.682 138.049C108.074 137.958 110.33 137.915 110.33 137.915C110.33 137.915 111.792 137.827 111.792 139.344C111.792 140.861 111.792 144.689 111.792 144.689C111.792 144.689 115.228 144.503 117.496 144.322C119.065 144.196 120.731 144.012 121.608 143.911C121.965 143.869 122.233 143.566 122.233 143.207V139.123C122.233 138.325 121.576 137.682 120.778 137.699L114.85 137.827V131.165C114.85 129.592 113.575 128.317 112.002 128.317H102.165Z",
    clipRule: "evenodd",
    opacity: 0.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.854,
    cy: 37.88,
    r: 3.568,
    fill: "#B0B0B0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6D6D6D",
    strokeLinecap: "round",
    strokeWidth: 2.136,
    d: "M43.366 26.3106C40.3545 26.4355 37.3797 27.6476 35.0804 29.9469C32.7351 32.2923 31.5209 35.3404 31.4379 38.4135"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6D6D6D",
    strokeLinecap: "round",
    strokeWidth: 2.136,
    d: "M43.8502 17.9083C43.4921 17.9089 43.134 17.9186 42.7763 17.9376C37.8175 18.2002 32.9346 20.2254 29.1468 24.0132C25.4583 27.7016 23.4412 32.4285 23.0955 37.2527C23.0649 37.6799 23.0474 38.1078 23.0429 38.5359"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.205,
    cy: 68.975,
    r: 3.204,
    stroke: "#404040",
    strokeWidth: 1.78
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.218,
    cy: 109.556,
    r: 2.027,
    stroke: "#6D6D6D",
    strokeWidth: 1.158
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#404040",
    strokeWidth: 2.136,
    d: "M69.663 0V9.73052"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#404040",
    strokeWidth: 2.136,
    d: "M64.7979 4.86519H74.5284"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6D6D6D",
    strokeWidth: 1.78,
    d: "M47.9038 108.241V120.028"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6D6D6D",
    strokeWidth: 1.78,
    d: "M42.0103 114.135H53.7972"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.002,
    cy: 65.158,
    r: 3.204,
    fill: "#2B2B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResponse);
export default __webpack_public_path__ + "static/media/no-response.7faa2ac6b133dd32b03e7815fb2dda11.svg";
export { ForwardRef as ReactComponent };